// extracted by mini-css-extract-plugin
export default {"left":"Left_left__63vOu","mobile":"Left_mobile__3mTpV","desktop":"Left_desktop__QYKUn"};